var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-column",attrs:{"id":"upload_document_template"}},[_c('action-button',{attrs:{"title":_vm.actionBtnTitle,"loading":_vm.loading,"role":"secondary"},on:{"click":_vm.actionTriggered}}),_c('input',{ref:"fileInput",staticClass:"clip",attrs:{"type":"file","id":"file","accept":".docx"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }